@import '../../../../globals/main.scss';

pn-stats-info-data {
  width: 50%;

  .pn-stats-info-data__container {
    width: 100%;

    background-color: transparent;
    color: $coral400;

    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2rem;

    @media screen and (min-width: $min-width-md) {
      justify-content: center;
      min-height: 102px;
      padding: 0 2rem;
    }

    @media screen and (min-width: $min-width-xl) {
      min-height: 125px;
    }
  }

  .pn-stats-info-data__container__content {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .pn-stats-info-data__container__content__data {
    font-weight: 700;
    font-size: 3rem;
    line-height: 110%;

    @media screen and (min-width: $min-width-xl) {
      font-size: 5.6rem;
    }
  }

  .pn-stats-info-data__container__content__unit {
    font-weight: 700;
    font-size: 3rem;
    line-height: 110%;

    margin-left: 0.8rem;

    @media screen and (min-width: $min-width-xl) {
      font-size: 5.6rem;
    }
  }

  .pn-stats-info-data__container__content__preamble {
    text-align: center;
    font-weight: 400;
    font-size: 1.4rem;
    line-height: 110%;
    color: $white;
  }
}
